import { render, staticRenderFns } from "./ExtModules.vue?vue&type=template&id=57d4f0ed&scoped=true"
import script from "./ExtModules.vue?vue&type=script&lang=js"
export * from "./ExtModules.vue?vue&type=script&lang=js"
import style0 from "./ExtModules.vue?vue&type=style&index=0&id=57d4f0ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4f0ed",
  null
  
)

export default component.exports